// extracted by mini-css-extract-plugin
export default {"mCard":"CE-z","image":"DE-z","imageNoBackground":"EE-z","imageHasCategory":"FE-z","fullWidth":"GE-z"};